<template>
  <div>
    <div class="baudotanim">
      <div class="baudotanim-text" ref="text"></div>
    </div>
    <PlayerControls :playing="playing" :progress="progress" @toggle="togglePlay" @reset="resetPlay" />
  </div>
</template>

<script>
import PlayerControls from "@/components/layout/PlayerControls";
import gsap from "gsap"

export default {
  components: {PlayerControls},
  props: {
    code: String
  },
  data: () => ({
    playing: false,
    progress: 0
  }),
  mounted() {
    this.createTimeline()
  },
  watch: {
    code() {
      this.progress = 0
      this.playing = false
      this.timeline && this.timeline.pause()
      this.$refs.text.innerHTML = ''
      this.createTimeline()
    }
  },
  methods: {
    // create gsap timeline that move arms according to current phrase steps
    createTimeline() {
      this.timeline = new gsap.timeline({
        paused: true,
        onComplete: () => {
          this.playing = false
        },
        onUpdate: () => {
          this.progress = this.timeline.progress()
        }
      })

      const numbers = this.code.split('')

      for(const n of numbers) {
        this.timeline.set(this.$refs.text, { textContent: n, delay: .5 })
        this.timeline.set(this.$refs.text, { textContent: '', delay: 1.2 })
      }
    },
    togglePlay() {
      this.playing = !this.playing
      if(this.playing) {
        if(this.progress === 1) {
          this.timeline.restart()
        } else {
          this.timeline.play()
        }
      } else {
        this.timeline.pause()
      }
    },
    resetPlay() {
      this.playing = true
      this.timeline.restart()
    }
  }
}
</script>

<style scoped lang="scss">
.baudotanim {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  font-weight: bold;
  line-height: 1;
}
</style>